import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataProvider } from 'src/app/logic';
import { BackendService } from 'src/app/services/backend.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-cha-mask2',
  templateUrl: './cha-mask2.component.html',
  styleUrls: ['./cha-mask2.component.scss']
})
export class ChaMask2Component extends DataProvider implements OnInit {

  constructor(route: ActivatedRoute, private _backend: BackendService, private _router: Router, private _userService: UserService) {
    super(route, _backend, _router, true, _userService);
  }

  ngOnInit(): void {
  }


}
